module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex justify-center align-center wrap flex-column success-page"
  }, [_c('img', {
    staticClass: "sp-confetti",
    attrs: {
      "src": require("../../assets/img/confetti.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ty-d2d"
  }, [_vm._v("\n    Thank you for booking with the "), _c('br'), _vm._v("\n    " + _vm._s(_vm.brandLabel) + " Flights!\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "ticket-copy"
  }, [(!_vm.isPending) ? _c('span', [_vm._v("We've sent you the ticket copy to your email.")]) : _c('span', [_vm._v("You will receive a booking confirmation notifications once your trip is confirmed with the airlines.")])]), _vm._v(" "), _c('div', {
    staticClass: "trip-details-box"
  }, [_c('div', {
    staticClass: "td-head"
  }, [_c('div', {
    staticClass: "td-field"
  }, [_vm._v("\n        Passenger Details:\n        "), _vm._l((_vm.pax.adult), function(p, i) {
    return _c('div', {
      key: ("a" + i)
    }, [_c('b', [_vm._v(_vm._s(((p['title' + i]) + " " + (p['firstName' + i]) + " " + (p['middleName' + i]) + " " + (p['lastName' + i]))))])])
  }), _vm._v(" "), _vm._l((_vm.pax.children), function(p, i) {
    return _c('div', {
      key: ("c" + i)
    }, [_c('b', [_vm._v(_vm._s(((p['title' + i]) + " " + (p['firstName' + i]) + " " + (p['middleName' + i]) + " " + (p['lastName' + i]))))])])
  }), _vm._v(" "), _vm._l((_vm.pax.infants), function(p, i) {
    return _c('div', {
      key: ("i" + i)
    }, [_c('b', [_vm._v(_vm._s(((p['title' + i]) + " " + (p['firstName' + i]) + " " + (p['middleName' + i]) + " " + (p['lastName' + i]))))])])
  })], 2), _vm._v(" "), (!_vm.isPending) ? _c('div', {
    staticClass: "td-field"
  }, [_vm._v("\n        Ticket ID:\n        "), _c('b', [_vm._v(_vm._s(_vm.booking.bookingRef.leg1.bookingId))]), (_vm.isReturning && _vm.settings.customFlight) ? _c('b', [_vm._v(", " + _vm._s(_vm.booking.bookingRef.leg2.bookingId))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.isPending) ? _c('div', {
    staticClass: "td-field"
  }, [_vm._v("\n        Ticket Number:\n        "), _c('b', [_vm._v(_vm._s(_vm.booking.bookingRef.leg1.pnr))]), (_vm.isReturning && _vm.settings.customFlight) ? _c('b', [_vm._v(", " + _vm._s(_vm.booking.bookingRef.leg2.pnr))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "td-body d-flex align-start"
  }, [_c('i', {
    staticClass: "fas fa-plane td-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "td-b-content"
  }, [_c('div', {
    staticClass: "td-b-label"
  }, [(_vm.isReturning) ? _c('span', [_vm._v("Roundtrip")]) : _c('span', [_vm._v("One Way")]), _vm._v(" \n          Flight\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "td-flight d-flex align-center"
  }, [_vm._v("\n          " + _vm._s(_vm.leg1Selected.flight[0].origin.AirportName) + " (" + _vm._s(_vm.leg1Selected.flight[0].origin.AirportCode) + ")\n          "), _c('i', {
    staticClass: "fas fa-plane"
  }), _vm._v("\n          " + _vm._s(_vm.leg1Selected.flight[_vm.leg1Selected.flight.length - 1].destination.AirportName) + " (" + _vm._s(_vm.leg1Selected.flight[_vm.leg1Selected.flight.length - 1].destination.AirportCode) + ")\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "td-airline d-flex align-center"
  }, [_c('div', [_vm._v(_vm._s(_vm.leg1Selected.flightName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dateFormat(_vm.leg1Selected.flight[0].origin.DateTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "td-airline d-flex align-center"
  }, [_vm._v("\n          " + _vm._s(_vm.timeFormat(_vm.leg1Selected.flight[0].origin.DateTime)) + "\n          -\n          " + _vm._s(_vm.timeFormat(_vm.leg1Selected.flight[_vm.leg1Selected.flight.length - 1].destination.DateTime)) + "\n          (" + _vm._s(_vm.timeDiff(_vm.leg1Selected.flight[0].origin.DateTime, _vm.leg1Selected.flight[_vm.leg1Selected.flight.length - 1].destination.DateTime)) + ", " + _vm._s(_vm.countStop(_vm.leg1Selected.flight)) + ")\n        ")]), _vm._v(" "), (_vm.isReturning) ? _c('div', {
    staticClass: "td-a-rt"
  }, [_c('div', {
    staticClass: "td-flight d-flex align-center"
  }, [_vm._v("\n            " + _vm._s(_vm.selectedLeg2Flight[0].origin.AirportName) + " (" + _vm._s(_vm.selectedLeg2Flight[0].origin.AirportCode) + ")\n            "), _c('i', {
    staticClass: "fas fa-plane"
  }), _vm._v("\n            " + _vm._s(_vm.selectedLeg2Flight[_vm.selectedLeg2Flight.length - 1].destination.AirportName) + " (" + _vm._s(_vm.selectedLeg2Flight[_vm.selectedLeg2Flight.length - 1].destination.AirportCode) + ")\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "td-airline d-flex align-center"
  }, [_c('div', [_vm._v(_vm._s(_vm.settings.customFlight ? _vm.leg2Selected.flightName : _vm.selectedLeg2Flight[0].airline.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dateFormat(_vm.selectedLeg2Flight[0].origin.DateTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "td-airline d-flex align-center"
  }, [_vm._v("\n            " + _vm._s(_vm.timeFormat(_vm.selectedLeg2Flight[0].origin.DateTime)) + "\n            -\n            " + _vm._s(_vm.timeFormat(_vm.selectedLeg2Flight[_vm.selectedLeg2Flight.length - 1].destination.DateTime)) + "\n            (" + _vm._s(_vm.timeDiff(_vm.selectedLeg2Flight[0].origin.DateTime, _vm.selectedLeg2Flight[_vm.selectedLeg2Flight.length - 1].destination.DateTime)) + ", " + _vm._s(_vm.countStop(_vm.selectedLeg2Flight)) + ")\n          ")])]) : _vm._e()])]), _vm._v(" "), (_vm.includedLandTranspo.length) ? _c('div', {
    staticClass: "td-body d-flex align-start"
  }, [_c('i', {
    staticClass: "fas fa-car-side td-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "td-b-content"
  }, [_c('div', {
    staticClass: "td-b-label"
  }, [_vm._v("Ground Transportation")]), _vm._v(" "), (!_vm.locations.isAirportPickup) ? _c('div', [(_vm.includedLandTranspo.indexOf(0) > -1) ? _c('div', {
    staticClass: "td-leg d-flex align-center"
  }, [_vm._v("\n            Leg 1 - Depart\n            "), _c('div', {
    staticClass: "td-status"
  }, [_vm._v("Upcoming")])]) : _vm._e(), _vm._v(" "), (_vm.includedLandTranspo.indexOf(0) > -1) ? _c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Pickup Location")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.locations.pickup.title))])]) : _vm._e(), _vm._v(" "), (_vm.includedLandTranspo.indexOf(0) > -1) ? _c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Dropoff Location")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.locations.pickupAirport.name) + " (" + _vm._s(_vm.locations.pickupAirport.code) + ")")])]) : _vm._e(), _vm._v(" "), (_vm.includedLandTranspo.indexOf(0) > -1) ? _c('div', {
    staticClass: "td-date d-flex align-start"
  }, [_c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Fleet Type")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.cabinLabel(_vm.findById('leg1', 'pickup').name)))])]), _vm._v(" "), _c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.dateFormat2(_vm.locations.pickupDetails.pickupTime.leg1, true)))])]), _vm._v(" "), _c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Time")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.timeFormat(_vm.locations.pickupDetails.pickupTime.leg1, true)))])])]) : _vm._e(), _vm._v(" "), (_vm.includedLandTranspo.indexOf(1) > -1) ? _c('div', {
    staticClass: "td-leg d-flex align-center"
  }, [_vm._v("\n            Leg 1 - Arrive\n            "), _c('div', {
    staticClass: "td-status"
  }, [_vm._v("Upcoming")])]) : _vm._e(), _vm._v(" "), (_vm.includedLandTranspo.indexOf(1) > -1) ? _c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Pickup Location")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.locations.dropoffAirport.name) + " (" + _vm._s(_vm.locations.dropoffAirport.code) + ")")])]) : _vm._e(), _vm._v(" "), (_vm.includedLandTranspo.indexOf(1) > -1) ? _c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Dropoff Location")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.locations.dropoff.title))])]) : _vm._e(), _vm._v(" "), (_vm.includedLandTranspo.indexOf(1) > -1) ? _c('div', {
    staticClass: "td-date d-flex align-start"
  }, [_c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Fleet Type")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.cabinLabel(_vm.findById('leg1', 'dropoff').name)))])]), _vm._v(" "), _c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.dateFormat2(_vm.locations.dropoffDetails.pickupTime.leg1, true)))])]), _vm._v(" "), _c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Time")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.timeFormat(_vm.locations.dropoffDetails.pickupTime.leg1, true)))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isReturning && !_vm.locations.isAirportPickup && !_vm.locations.isAirportDropoff && ((_vm.includedLandTranspo.includes(0) || _vm.includedLandTranspo.includes(1)) && (_vm.includedLandTranspo.includes(2) || _vm.includedLandTranspo.includes(3)))) ? _c('hr', {
    staticClass: "ground-hr"
  }) : _vm._e(), _vm._v(" "), (!_vm.locations.isAirportDropoff) ? _c('div', [(_vm.includedLandTranspo.indexOf(2) > -1 && _vm.isReturning) ? _c('div', {
    staticClass: "td-leg d-flex align-center"
  }, [_vm._v("\n            Leg 2 - Depart\n            "), _c('div', {
    staticClass: "td-status"
  }, [_vm._v("Upcoming")])]) : _vm._e(), _vm._v(" "), (_vm.includedLandTranspo.indexOf(2) > -1 && _vm.isReturning) ? _c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Pickup Location")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.locations.dropoff.title))])]) : _vm._e(), _vm._v(" "), (_vm.includedLandTranspo.indexOf(2) > -1 && _vm.isReturning) ? _c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Dropoff Location")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.locations.dropoffAirport.name) + " (" + _vm._s(_vm.locations.dropoffAirport.code) + ")")])]) : _vm._e(), _vm._v(" "), (_vm.includedLandTranspo.indexOf(2) > -1 && _vm.isReturning) ? _c('div', {
    staticClass: "td-date d-flex align-start"
  }, [_c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Fleet Type")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.cabinLabel(_vm.findById('leg2', 'pickup').name)))])]), _vm._v(" "), _c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.dateFormat2(_vm.locations.pickupDetails.pickupTime.leg2, true)))])]), _vm._v(" "), _c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Time")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.timeFormat(_vm.locations.pickupDetails.pickupTime.leg2, true)))])])]) : _vm._e(), _vm._v(" "), (_vm.includedLandTranspo.indexOf(3) > -1 && _vm.isReturning) ? _c('div', {
    staticClass: "td-leg d-flex align-center"
  }, [_vm._v("\n            Leg 2 - Arrive\n            "), _c('div', {
    staticClass: "td-status"
  }, [_vm._v("Upcoming")])]) : _vm._e(), _vm._v(" "), (_vm.includedLandTranspo.indexOf(3) > -1 && _vm.isReturning) ? _c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Pickup Location")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.locations.pickupAirport.name) + " (" + _vm._s(_vm.locations.pickupAirport.code) + ")")])]) : _vm._e(), _vm._v(" "), (_vm.includedLandTranspo.indexOf(3) > -1 && _vm.isReturning) ? _c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Dropoff Location")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.locations.pickup.title))])]) : _vm._e(), _vm._v(" "), (_vm.includedLandTranspo.indexOf(3) > -1 && _vm.isReturning) ? _c('div', {
    staticClass: "td-date d-flex align-start"
  }, [_c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Fleet Type")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.cabinLabel(_vm.findById('leg2', 'dropoff').name)))])]), _vm._v(" "), _c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.dateFormat2(_vm.locations.dropoffDetails.pickupTime.leg2, true)))])]), _vm._v(" "), _c('div', {
    staticClass: "td-field"
  }, [_c('div', {
    staticClass: "td-f-label"
  }, [_vm._v("Time")]), _vm._v(" "), _c('div', {
    staticClass: "td-f-value"
  }, [_vm._v(_vm._s(_vm.timeFormat(_vm.locations.dropoffDetails.pickupTime.leg2, true)))])])]) : _vm._e()]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "success-box"
  }, [_c('div', {
    staticClass: "sb-padder"
  }, [(_vm.isPending) ? _c('i', {
    staticClass: "fas fa-clock fa-5x"
  }) : _c('i', {
    staticClass: "fas fa-check-circle fa-5x"
  }), _vm._v(" "), (_vm.isPending) ? _c('div', {
    staticClass: "text1"
  }, [_vm._v("Booking Pending!")]) : _c('div', {
    staticClass: "text1"
  }, [_vm._v("Booking Success!")]), _vm._v(" "), _c('div', {
    staticClass: "text2"
  }, [_vm._v("\n        Thank you for booking with us!\n        "), (_vm.isPending) ? _c('div', [_vm._v("You will receive a booking confirmation notifications once your trip is confirmed with the airlines.")]) : _vm._e()]), _vm._v(" "), (!_vm.isPending && !_vm.isReturning) ? _c('div', {
    staticClass: "booking-info"
  }, [_c('div', [_vm._v("Booking ID")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.booking.bookingRef.leg1.bookingId))])]) : _vm._e(), _vm._v(" "), (_vm.booking.bookingRef.leg1.pnr && !_vm.isPending && !_vm.isReturning) ? _c('div', {
    staticClass: "booking-info"
  }, [_c('div', [_vm._v("Airline PNR")]), _vm._v(" "), _c('b', [_vm._v("\n          " + _vm._s(_vm.booking.bookingRef.leg1.pnr) + "\n        ")])]) : _vm._e()]), _vm._v(" "), (_vm.isReturning) ? _c('div', {
    staticClass: "dual-book d-flex"
  }, [_c('div', [_c('div', {
    staticClass: "margin-b-s"
  }, [_c('label', {
    staticClass: "label-type"
  }, [_vm._v("FIRST TRIP")]), _vm._v(" "), _c('label', [_vm._v("Booking ID")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.booking.bookingRef.leg1.bookingId))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Airline PNR")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.booking.bookingRef.leg1.pnr))])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "margin-b-s"
  }, [_c('label', {
    staticClass: "label-type"
  }, [_vm._v("RETURN TRIP")]), _vm._v(" "), _c('label', [_vm._v("Booking ID")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.booking.bookingRef.leg2.bookingId))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("Airline PNR")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.booking.bookingRef.leg2.pnr))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sb-padder"
  }, [_c('div', {
    staticClass: "booking-info margin-b-z"
  }, [_c('div', [_vm._v("Confirmation "), (_vm.isPending) ? _c('span', [_vm._v("will be")]) : _vm._e(), _vm._v(" sent to")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.user.email))])])])]) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-link"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Back to Home page")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-61d55c4c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61d55c4c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/D2DOthers/Success.vue
// module id = 2102
// module chunks = 0